module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"react","commonjs2":"react","amd":"react"}
// module id = 0
// module chunks = 0